import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { updatePractice } from 'api/Practice';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import ImageUploader from 'components/shared/ImageUploader/ImageUploader';

const PracticeBrandingForm = ({
  addFooterActions,
  setHeaderButtonProps,
  mutateOrchestratorData,
  onNext,
  orchestratorLoading
}) => {
  const { practice } = useOutletContext();
  const navigate = useNavigate();
  const [header_photo, setHeaderPhoto] = useState(practice?.header_photo || null);

  const updatePracticeMutation = useCustomMutation({
    mutationFn: () =>
      updatePractice(navigate, {
        practice_id: practice.id,
        fields: {
          header_photo
        }
      }),
    disableAlert: true
  });

  const handleSubmit = async () => {
    if (header_photo === practice?.header_photo) {
      onNext();
      return;
    }
    await updatePracticeMutation.mutateAsync();
    mutateOrchestratorData();
  };

  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Continue',
        onClick: handleSubmit,
        disabled: orchestratorLoading
      }
    ]);
  }, [header_photo, orchestratorLoading]);

  return (
    <>
      <div className="w-full">
        <ImageUploader
          handlers={
            header_photo ? [JSON.parse(header_photo)[Object.keys(JSON.parse(header_photo))[0]]] : []
          }
          onDelete={() => {
            setHeaderPhoto(null);
          }}
          onUpload={(file) => {
            const ext = file.name.split('.').pop();
            const minimal = { [ext]: file.handle };

            const header_photo = JSON.stringify(minimal);
            setHeaderPhoto(header_photo);
          }}
        />
      </div>
    </>
  );
};

export default PracticeBrandingForm;
